module.exports = __webpack_public_path__ + "img/yingYeZhiZhao.91cd4699.png";